import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function App() {
  return <div className="w-full min-h-screen bg-cream" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <HookSection data-id="element-3" />
      <PainAgitationSection data-id="element-4" />
      <RevelationSection data-id="element-5" />
      <ProtocolFeaturesSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FinalCTASection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}
function UrgencyBar() {
  return <motion.div initial={{
    y: -100
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 right-0 z-50 bg-urgency text-white py-3 px-4 shadow-lg" data-id="element-13">
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-2 text-center text-sm md:text-base font-medium" data-id="element-14">
        <motion.span animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} className="text-xl" data-id="element-15">
          🔴
        </motion.span>
        <span data-id="element-16">
          <strong data-id="element-17">ATENCIÓN:</strong> Debido a la alta demanda, el precio con
          descuento para el protocolo "El Código Hormonal 40+" está sujeto a
          cambios. Cupo limitado disponible.
        </span>
      </div>
    </motion.div>;
}
function HeroSection() {
  return <section className="pt-24 pb-16 px-4 bg-gradient-to-b from-cream to-white" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-20">
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-sage mb-6 leading-tight" data-id="element-21">
            ¿Sientes que tu metabolismo se ha{' '}
            <span className="text-gold" data-id="element-22">"congelado"</span> después de los 40?
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 mb-4 max-w-4xl mx-auto leading-relaxed" data-id="element-23">
            El primer protocolo de <strong data-id="element-24">Reseteo Metabólico</strong> diseñado
            para mujeres que quieren recuperar su cintura y su energía sin pasar
            hambre ni matarse a cardio.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="max-w-2xl mx-auto mb-12" data-id="element-25">
          <img src="https://cdn.magicpatterns.com/uploads/fQgodQzqVhLaQBUcVBBzyo/heylloyd-image-1774892938641.png" alt="El Código Hormonal 40+ Mockup" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-26" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="text-center" data-id="element-27">
          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-3xl mx-auto italic" data-id="element-28">
            No es tu falta de voluntad. No es "la edad". Es tu{' '}
            <strong data-id="element-29">Cortisol e Insulina</strong>. Descubre cómo hablar el nuevo
            idioma de tu cuerpo y eliminar la inflamación abdominal en solo 21
            días.
          </p>
          <CTAButton data-id="element-30" />
        </motion.div>
      </div>
    </section>;
}
function HookSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-31">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-32">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-sage mb-8 text-center" data-id="element-33">
          🌙 ¿Te suena familiar?
        </h2>
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6" data-id="element-34">
          <p className="text-lg leading-relaxed" data-id="element-35">
            ¿Te despiertas a las 3:00 AM con la mente a mil por hora y una
            ansiedad que no te deja descansar? ¿Sientes que, de la noche a la
            mañana, ha aparecido una "llanta" abdominal que no se va aunque
            cierres la boca?
          </p>
          <p className="text-lg leading-relaxed" data-id="element-36">
            Si has notado que las dietas que te funcionaban a los 30 hoy no
            mueven ni un gramo de la balanza, <strong data-id="element-37">no estás sola</strong>.
            Las reglas de tu cuerpo han cambiado, y seguir intentando "comer
            menos y moverte más" es, irónicamente, lo que está bloqueando tu
            pérdida de peso.
          </p>
        </div>
      </motion.div>
    </section>;
}
function PainAgitationSection() {
  return <section className="py-16 px-4 bg-sage/5" data-id="element-38">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-39">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-sage mb-8 text-center" data-id="element-40">
          😔 La Frustración que Nadie Entiende
        </h2>
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-6" data-id="element-41">
          <p className="text-lg leading-relaxed text-gray-700" data-id="element-42">
            Es frustrante mirarte al espejo y no reconocer a la mujer que tienes
            delante. Sentirte hinchada, irritable y con una "neblina mental" que
            te hace sentir que vas a medio gas. Te han dicho que{' '}
            <em data-id="element-43">"es lo normal a tu edad"</em> y que te resignes.
          </p>
          <div className="border-l-4 border-gold pl-6 py-2" data-id="element-44">
            <p className="text-lg leading-relaxed text-gray-700 font-medium" data-id="element-45">
              Pero la realidad es más profunda: mientras sigas intentando dietas
              restrictivas y ejercicio cardiovascular intenso, estás enviando
              una señal de <strong className="text-urgency" data-id="element-46">PÁNICO</strong> a
              tus glándulas adrenales.
            </p>
          </div>
          <p className="text-lg leading-relaxed text-gray-700" data-id="element-47">
            Tu cuerpo interpreta que hay una amenaza, dispara el cortisol y
            bloquea la quema de grasa abdominal para proteger tus órganos. Estás
            peleando una batalla biológica que no puedes ganar con fuerza de
            voluntad.
          </p>
        </div>
      </motion.div>
    </section>;
}
function RevelationSection() {
  return <section className="py-16 px-4 bg-gradient-to-b from-white to-cream" data-id="element-48">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto text-center" data-id="element-49">
        <div className="inline-block mb-6" data-id="element-50">
          <span className="text-6xl" data-id="element-51">💡</span>
        </div>
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-sage mb-8" data-id="element-52">
          La Clave Está en Hablar el Idioma de Tus Hormonas
        </h2>
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6 text-left" data-id="element-53">
          <p className="text-lg leading-relaxed" data-id="element-54">
            He condensado años de investigación en endocrinología femenina
            funcional en un solo lugar:{' '}
            <strong className="text-gold text-xl" data-id="element-55">
              El Código Hormonal 40+
            </strong>
            .
          </p>
          <p className="text-lg leading-relaxed" data-id="element-56">
            Este no es un libro de "dieta". Es el{' '}
            <strong data-id="element-57">
              manual de instrucciones que debieron darte al cumplir los 40
            </strong>
            . Aprenderás a resetear las tres señales químicas que dictan tu
            peso: <strong data-id="element-58">Insulina, Cortisol y Estrógeno</strong>. Al
            estabilizar estas hormonas en un orden exacto, tu cuerpo finalmente
            recibe la señal de "paz" necesaria para soltar las reservas de grasa
            acumulada.
          </p>
        </div>
      </motion.div>
    </section>;
}
function ProtocolFeaturesSection() {
  const features = [{
    icon: <ClockIcon data-id="element-59" />,
    title: '🕐 La Ventana de Alimentación 40+',
    description: 'El horario exacto para comer según tu ritmo circadiano (adiós insomnio).'
  }, {
    icon: <LeafIcon data-id="element-60" />,
    title: '🌿 Nutrición Anti-Cortisol',
    description: 'La lista de alimentos que "apagan" la señal de alarma de tus glándulas adrenales.'
  }, {
    icon: <CalendarIcon data-id="element-61" />,
    title: '📅 El Plan de Reseteo de 21 Días',
    description: 'Un paso a paso diseñado para desinflamar tu sistema digestivo y recuperar tu claridad mental.'
  }, {
    icon: <UtensilsIcon data-id="element-62" />,
    title: '🍽️ La Secuencia de Alimentos',
    description: 'El orden en que debes comer para reducir el pico de insulina hasta en un 75%.'
  }];
  return <section className="py-16 px-4 bg-sage text-white" data-id="element-63">
      <div className="max-w-6xl mx-auto" data-id="element-64">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif font-bold text-center mb-12" data-id="element-65">
          ✨ Qué Encontrarás Dentro del Protocolo
        </motion.h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-66">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300" data-id="element-67">
              <div className="flex items-start gap-4" data-id="element-68">
                <div className="flex-shrink-0 w-12 h-12 text-gold" data-id="element-69">
                  {feature.icon}
                </div>
                <div data-id="element-70">
                  <h3 className="text-xl font-bold mb-3" data-id="element-71">{feature.title}</h3>
                  <p className="text-white/90 leading-relaxed" data-id="element-72">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
function TestimonialsSection() {
  const testimonials = [{
    name: 'Elena R.',
    age: 49,
    result: '-5kg en 21 días',
    text: 'A los 49 años pensaba que mi cuerpo estaba roto. En la segunda semana del Código Hormonal, volví a dormir 7 horas seguidas. He bajado 4 kilos de inflamación y mi neblina mental ha desaparecido por completo.',
    emoji: '⭐'
  }, {
    name: 'Carmen G.',
    age: 52,
    result: 'Adiós sofocos en 14 días',
    text: 'Lo mejor no es el peso, es la energía. Ya no necesito siesta ni tengo antojos de dulce a las 5 de la tarde. Por fin entiendo qué le pasaba a mis hormonas.',
    emoji: '💪'
  }];
  return <section className="py-16 px-4 bg-cream" data-id="element-73">
      <div className="max-w-6xl mx-auto" data-id="element-74">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif font-bold text-sage text-center mb-12" data-id="element-75">
          💬 Lo Que Dicen Mujeres Como Tú
        </motion.h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-76">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white rounded-2xl shadow-lg p-8 relative" data-id="element-77">
              <div className="text-5xl mb-4" data-id="element-78">{testimonial.emoji}</div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-79">
                "{testimonial.text}"
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-80">
                <p className="font-bold text-sage" data-id="element-81">
                  {testimonial.name}, {testimonial.age} años
                </p>
                <p className="text-gold font-semibold mt-1" data-id="element-82">
                  🎯 {testimonial.result}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
function PricingSection() {
  return <section id="pricing" className="py-16 px-4 bg-gradient-to-b from-white to-cream" data-id="element-83">
      <div className="max-w-4xl mx-auto text-center" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-sage mb-6" data-id="element-86">
            🎁 Precio de Lanzamiento
          </h2>
          <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-87">
            Para validar este método con la mayor cantidad de mujeres posible,
            puedes acceder al protocolo completo hoy mismo por un precio de
            lanzamiento único.
          </p>

          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 max-w-lg mx-auto border-4 border-gold" data-id="element-88">
            <div className="mb-6" data-id="element-89">
              <p className="text-gray-500 line-through text-2xl mb-2" data-id="element-90">
                $27.00 USD
              </p>
              <div className="flex items-baseline justify-center gap-2" data-id="element-91">
                <span className="text-6xl font-bold text-sage" data-id="element-92">$6.36</span>
                <span className="text-2xl text-gray-600" data-id="element-93">USD</span>
              </div>
              <p className="text-sm text-gray-600 mt-3" data-id="element-94">
                Pago único • Descarga digital instantánea en PDF
              </p>
            </div>

            <div className="space-y-3 mb-8 text-left" data-id="element-95">
              <div className="flex items-start gap-3" data-id="element-96">
                <span className="text-green-600 text-xl flex-shrink-0" data-id="element-97">✅</span>
                <span className="text-gray-700" data-id="element-98">
                  Acceso inmediato al protocolo completo de 60 páginas
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-99">
                <span className="text-green-600 text-xl flex-shrink-0" data-id="element-100">✅</span>
                <span className="text-gray-700" data-id="element-101">
                  Plan de 21 días paso a paso
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-102">
                <span className="text-green-600 text-xl flex-shrink-0" data-id="element-103">✅</span>
                <span className="text-gray-700" data-id="element-104">
                  Listas de alimentos y secuencias hormonales
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-105">
                <span className="text-green-600 text-xl flex-shrink-0" data-id="element-106">✅</span>
                <span className="text-gray-700" data-id="element-107">
                  Garantía de satisfacción de 7 días
                </span>
              </div>
            </div>

            <CTAButton large data-id="element-108" />
          </div>
        </motion.div>
      </div>
    </section>;
}
function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '❓ ¿Tengo que comprar alimentos raros?',
    answer: '✅ No. Todo lo que necesitas está en tu supermercado local. Se trata de cómo y cuándo combinas los alimentos, no de productos exóticos.'
  }, {
    question: '❓ ¿Es muy difícil de seguir?',
    answer: '✅ Al contrario. Está diseñado para mujeres reales con vidas ocupadas. No hay conteo de calorías ni pesaje de alimentos.'
  }, {
    question: '❓ ¿Funciona si ya pasé la menopausia?',
    answer: '✅ Sí. El metabolismo hormonal no se detiene, solo cambia de fase. Este protocolo es vital para mantener la salud metabólica en la postmenopausia.'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif font-bold text-sage text-center mb-12" data-id="element-111">
          🤔 Preguntas Frecuentes
        </motion.h2>
        <div className="space-y-4" data-id="element-112">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-113">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between bg-cream hover:bg-gold/10 transition-colors" data-id="element-114">
                <span className="font-semibold text-sage text-lg" data-id="element-115">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-sage transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-116" />
              </button>
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} className="px-6 py-5 bg-white text-gray-700 leading-relaxed" data-id="element-117">
                  {faq.answer}
                </motion.div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}
function GuaranteeSection() {
  return <section className="py-16 px-4 bg-sage/5" data-id="element-118">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto text-center" data-id="element-119">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border-2 border-gold" data-id="element-120">
          <div className="text-6xl mb-6" data-id="element-121">🛡️</div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-sage mb-6" data-id="element-122">
            Garantía de Satisfacción de 7 Días
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-123">
            Prueba el Código por 7 Días: Si después de leer el manual sientes
            que no es lo que necesitas para recuperar tu vitalidad, escríbeme y
            te devolveré tu inversión. Mi prioridad es que vuelvas a sentirte
            dueña de tu cuerpo.
          </p>
        </div>
      </motion.div>
    </section>;
}
function FinalCTASection() {
  return <section className="py-20 px-4 bg-gradient-to-b from-cream to-gold/20" data-id="element-124">
      <div className="max-w-4xl mx-auto text-center" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-126">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-sage mb-8" data-id="element-127">
            Tienes Dos Caminos Ahora Mismo
          </h2>
          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-128">
            <div className="bg-gray-100 rounded-2xl p-8 text-left" data-id="element-129">
              <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-130">
                ❌ Camino A
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-131">
                No hacer nada. Seguir despertando cansada, resignarte a la ropa
                ancha y dejar que tus hormonas dicten tu humor y tu salud.
              </p>
            </div>
            <div className="bg-gold/20 border-2 border-gold rounded-2xl p-8 text-left" data-id="element-132">
              <h3 className="text-2xl font-bold text-sage mb-4" data-id="element-133">✅ Camino B</h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-134">
                Tomar el control. Descubrir el Código, recuperar tu cuerpo y
                entrar en tu segunda mitad con más fuerza de la que tenías a los
                30.
              </p>
            </div>
          </div>
          <CTAButton large data-id="element-135" />
        </motion.div>
      </div>
    </section>;
}
function Footer() {
  const [showModal, setShowModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-sage text-white py-8 px-4" data-id="element-136">
        <div className="max-w-6xl mx-auto text-center space-y-3" data-id="element-137">
          <div className="flex items-center justify-center gap-4 text-sm" data-id="element-138">
            <button onClick={() => setShowModal('privacy')} className="underline underline-offset-2 opacity-80 hover:opacity-100 transition-opacity" data-id="element-139">
              Política de Privacidad
            </button>
            <span className="opacity-40" data-id="element-140">|</span>
            <button onClick={() => setShowModal('terms')} className="underline underline-offset-2 opacity-80 hover:opacity-100 transition-opacity" data-id="element-141">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-sm opacity-80" data-id="element-142">
            © 2024 El Código Hormonal 40+. Todos los derechos reservados.
          </p>
          <p className="text-xs opacity-60" data-id="element-143">
            Este producto es informativo y no sustituye el consejo médico
            profesional.
          </p>
        </div>
      </footer>

      {showModal && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4" onClick={() => setShowModal(null)} data-id="element-144">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 md:p-10" onClick={e => e.stopPropagation()} data-id="element-145">
            <div className="flex items-center justify-between mb-6" data-id="element-146">
              <h2 className="text-2xl font-serif font-bold text-sage" data-id="element-147">
                {showModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setShowModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 transition-colors text-lg" data-id="element-148">
                ✕
              </button>
            </div>

            {showModal === 'privacy' ? <div className="text-gray-700 space-y-4 text-sm leading-relaxed" data-id="element-149">
                <p data-id="element-150">
                  <strong data-id="element-151">Última actualización:</strong> Enero 2024
                </p>
                <p data-id="element-152">
                  Tu privacidad es importante para nosotros. Esta política
                  describe cómo recopilamos, usamos y protegemos tu información
                  personal.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-153">
                  1. Información que Recopilamos
                </h3>
                <p data-id="element-154">
                  Recopilamos únicamente la información necesaria para procesar
                  tu compra: nombre, dirección de correo electrónico y datos de
                  pago. No almacenamos datos de tarjetas de crédito en nuestros
                  servidores.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-155">
                  2. Uso de la Información
                </h3>
                <p data-id="element-156">
                  Utilizamos tu información para: procesar tu pedido, enviarte
                  el producto digital adquirido y comunicarnos contigo sobre tu
                  compra. No vendemos ni compartimos tu información con
                  terceros.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-157">
                  3. Protección de Datos
                </h3>
                <p data-id="element-158">
                  Implementamos medidas de seguridad técnicas y organizativas
                  para proteger tu información personal contra acceso no
                  autorizado, alteración o destrucción.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-159">
                  4. Cookies
                </h3>
                <p data-id="element-160">
                  Nuestro sitio puede utilizar cookies para mejorar tu
                  experiencia de navegación y analizar el tráfico del sitio.
                  Puedes configurar tu navegador para rechazar cookies.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-161">
                  5. Tus Derechos
                </h3>
                <p data-id="element-162">
                  Tienes derecho a acceder, rectificar o eliminar tu información
                  personal en cualquier momento. También puedes solicitar la
                  portabilidad de tus datos.
                </p>
              </div> : <div className="text-gray-700 space-y-4 text-sm leading-relaxed" data-id="element-163">
                <p data-id="element-164">
                  <strong data-id="element-165">Última actualización:</strong> Enero 2024
                </p>
                <p data-id="element-166">
                  Al adquirir "El Código Hormonal 40+", aceptas los siguientes
                  términos y condiciones.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-167">
                  1. Producto Digital
                </h3>
                <p data-id="element-168">
                  "El Código Hormonal 40+" es un producto digital informativo en
                  formato PDF. Al completar la compra, recibirás acceso
                  inmediato para descargar el material.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-169">
                  2. Uso Personal
                </h3>
                <p data-id="element-170">
                  El contenido adquirido es para uso personal exclusivamente.
                  Queda prohibida la reproducción, distribución o reventa del
                  material sin autorización expresa.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-171">
                  3. Garantía de Satisfacción
                </h3>
                <p data-id="element-172">
                  Ofrecemos una garantía de satisfacción de 7 días. Si no estás
                  satisfecha con el producto, puedes solicitar un reembolso
                  completo dentro de los 7 días posteriores a la compra.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-173">
                  4. Descargo de Responsabilidad
                </h3>
                <p data-id="element-174">
                  Este producto es informativo y educativo. No sustituye el
                  consejo médico profesional. Consulta a tu médico antes de
                  realizar cambios significativos en tu alimentación o estilo de
                  vida.
                </p>
                <h3 className="font-bold text-sage text-base mt-4" data-id="element-175">
                  5. Propiedad Intelectual
                </h3>
                <p data-id="element-176">
                  Todo el contenido, incluyendo textos, gráficos y diseño, está
                  protegido por derechos de autor. Cualquier uso no autorizado
                  será perseguido conforme a la ley.
                </p>
              </div>}

            <button onClick={() => setShowModal(null)} className="mt-8 w-full bg-sage text-white py-3 rounded-xl font-semibold hover:bg-sage/90 transition-colors" data-id="element-177">
              Cerrar
            </button>
          </motion.div>
        </div>}
    </>;
}
function CTAButton({
  large = false
}: {
  large?: boolean;
}) {
  return <motion.a href="https://flujovital.com/cart/51282425676080:1" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`inline-block bg-gold hover:bg-gold/90 text-sage font-bold rounded-full shadow-2xl transition-all duration-300 text-center ${large ? 'px-12 py-6 text-xl' : 'px-8 py-4 text-lg'}`} data-id="element-178">
      👉 SÍ, QUIERO MI CÓDIGO HORMONAL — ACCESO INMEDIATO
    </motion.a>;
}
// Custom SVG Icons
function ClockIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full" data-id="element-179">
      <circle cx="12" cy="12" r="10" data-id="element-180" />
      <polyline points="12 6 12 12 16 14" data-id="element-181" />
    </svg>;
}
function LeafIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full" data-id="element-182">
      <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-183" />
      <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-184" />
    </svg>;
}
function CalendarIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full" data-id="element-185">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-186" />
      <line x1="16" y1="2" x2="16" y2="6" data-id="element-187" />
      <line x1="8" y1="2" x2="8" y2="6" data-id="element-188" />
      <line x1="3" y1="10" x2="21" y2="10" data-id="element-189" />
    </svg>;
}
function UtensilsIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full" data-id="element-190">
      <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" data-id="element-191" />
      <path d="M7 2v20" data-id="element-192" />
      <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" data-id="element-193" />
    </svg>;
}